import { styled } from "@material-ui/core"
import { InfoOutlined } from "@material-ui/icons"

export const InfoIcon = styled(InfoOutlined)({
  cursor: "default",
  marginLeft: 5,
  verticalAlign: "top"
})
